import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      py: 3,
      px: 3,
    };

    this.heading = {
      variant: 'text.h6',
      fontSize: '14px',
      fontWeight: 500,
      letterSpacing: '0.28px',
      textAlign: 'center',
      mt: 3,
      mb: 5,
    };

    this.slider = {
      position: 'relative',
      border: (t) => `1px solid ${t.colors.gray}`,
      cursor: 'grab',
    };
  })()
);
